
  <div class='modal-container'>
    <div class='img-container' width='240'>
      <button type='button' class='modal-close-btn'>
        <svg class='modal-close-icon' data-btn='close'>

          <path d='M8 8L22 22' stroke='black' stroke-width='2'></path>
          <path d='M8 22L22 8' stroke='black' stroke-width='2'></path>

        </svg>
      </button>
      <img
        class='image'
        src='https://image.tmdb.org/t/p/w300/{{this.poster_path}}'
        alt='{{this.title}}'
      />
    </div>
    <div class='movie-description'>
      <h2 class='movie-name'>{{this.title}}</h2>
      <div class='grid-container'>
        <i class='movie-item_title'>Vote / Votes</i>
        <div class='value'>
          <span class='vote vote_focus'>{{this.vote_average}}</span>
          <span> / </span>
          <span class='votes votes_unactive'>{{this.vote_count}}</span>
        </div>
        <i class='movie-item_title'>Popularity</i>
        <span class='value'>{{popularity}}</span>
        <i class='movie-item_title'>Original Title</i>
        <span class='value'>{{this.original_title}}</span>
        <i class='movie-item_title'>Genre</i>
        <span class='value'>{{this.genres}}</span>
      </div>
      <h3 class='about_title'>About</h3>
      <article class='about_text'>
        {{this.overview}}</article>

      <div class='buttons-block'>
        <button class='modal-button' data-name='watched'>add to Watched</button>
        <button class='modal-button' data-name='queue'>add to queue</button>
        <button class='modal-button trailerShow'>watch trailer</button>
      </div>
    </div>
    <div class="video">
    <iframe
      class='hidden'
      height='315'
      src='{{this.movie}}'
      title='YouTube video player'
      frameborder='0'
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      allowfullscreen
      type="text/html"
    ></iframe>
    </div>
  </div>

